export class CardPaymentStateModel {
    public deposit: number;
    public minDeposit: number;
    public maxDeposit: number;
    public percentage: number;
    public amountLeft: number;
    public isReadonlyMaxValue: boolean;
}